export default __webpack_public_path__ + "static/media/arrow-down.inline.9b055125.svg";